import { nuc } from '../../utils';
import { get, post, put, remove } from '../api';
import type { Comment } from '../../../shared/model-typings';
import type { User } from '../../types';

type CommentBody = { body: string; projectId: string };

export type CommentUser = Pick<User, 'username' | 'email'> & {
  github?: {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    avatar_url: string;
  }
};

export type CommentWithUser = Required<Comment> & {
  user: CommentUser;
};

export default {
  fetchAll: (projectId: string) => ({
    type: `FETCH_COMMENTS`,
    async payload() {
      const { data } = await get<CommentWithUser>(`/api/comments`, true, { projectId: nuc(projectId) });
      return {
        data,
        projectId,
      };
    },
  }),
  create: (projectId: string, createBody: CommentBody) => ({
    type: 'CREATE_COMMENTS',
    async payload() {
      const { data } = await post(`/api/comments`, createBody);
      return {
        data,
        projectId,
      };
    },
  }),
  update: (id: number, projectId: string, updateBody: CommentBody) => ({
    type: `UPDATE_COMMENTS`,
    async payload() {
      const { data } = await put(`/api/comments/${id}`, updateBody);
      return {
        data,
        projectId,
      };
    },
  }),
  delete: (id: number, projectId: string) => {
    return {
      type: `DELETE_COMMENTS`,
      async payload() {
        const { data } = await remove(`/api/comments/${id}`);
        return {
          data,
          projectId,
          id,
        };
      },
    };
  },
};
